import { render, staticRenderFns } from "./IbCustomerLookup.vue?vue&type=template&id=a5c9a0a6&scoped=true"
import script from "./IbCustomerLookup.vue?vue&type=script&lang=js"
export * from "./IbCustomerLookup.vue?vue&type=script&lang=js"
import style0 from "./IbCustomerLookup.vue?vue&type=style&index=0&id=a5c9a0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c9a0a6",
  null
  
)

export default component.exports